import { Text } from "libs/purple-ui";

export function Subtitle({ children, ...rest }) {
  return <Text {...rest}>{children}</Text>;
}
